import React from "react";
import Header from "../../components/header";
import "../../assets/css/style.css";
import Footer from "../../components/Footer";
import { allsec } from "../../constant";


const Home = () => {
  return (
    <>
      <Header />
      {/* banner starts here */}
      <section className="banner">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="banner-content-wrapper">
                <h1>We Have Everything Your Car Needs</h1>
                <p>
                  Curabitur aliquet quam id dui posuere blandit. Vivamus
                  suscipit tortor eget felis porttitor volutpat. Nulla quis
                  lorem ut libero malesuada feugiat..
                </p>
                <a href="#" className="btn">
                  Discover More
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="catergory-wrappers">
                <form action="">
                  <div className="catergory-search-wrapper">
                    <input
                      type="search"
                      className="form-ccontrol"
                      placeholder="Category/Industry"
                    />
                    <button className="btn">
                      <i class="fa-solid fa-magnifying-glass"></i>
                    </button>
                  </div>
                </form>
              </div>
              <div className="book-category-wrapper">
                <div className="book-heading-wrapper">
                    <h6>Book Online The Car You Want, Your Way</h6>
                </div>
                <form action="">
                  <div className="form-group row">
                    <div className="col-lg-4">
                      <select name="" id="" className="form-control">
                        <option value="- Select Brands -" selected disabled>
                          - Select Brands -
                        </option>
                      </select>
                    </div>
                    <div className="col-lg-4">
                      <select name="" id="" className="form-control">
                        <option value="- Select Brands -" selected disabled>
                          - Condition -
                        </option>
                      </select>
                    </div>
                    <div className="col-lg-4">
                      <select name="" id="" className="form-control">
                        <option value="- Select Brands -" selected disabled>
                          - Select Color -
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-lg-4">
                      <select name="" id="" className="form-control">
                        <option value="- Select Brands -" selected disabled>
                          - Select Date -
                        </option>
                      </select>
                    </div>
                    <div className="col-lg-4">
                      <select name="" id="" className="form-control">
                        <option value="- Select Brands -" selected disabled>
                          - Select Location -
                        </option>
                      </select>
                    </div>
                    <div className="col-lg-4">
                      <button type="submit" className="btn">Request Quote</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner ends here */}
      <div className="all-sec-wrapper">
        <figure>
          <img src={allsec} className="img-fluid" alt="" />
        </figure>
      </div>
      <Footer/>
    </>
  );
};

export default Home;
